module.exports = __webpack_public_path__ + "static/karina-e0064476ea54e39de2738dbd99a6e669.jpg";